//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Address

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The venue model
* 
* @param id The venue id
* @param name The venue name
* @param address 
* @param headerImage The header image id of the venue. requesting images via \"Common Media\" endpoints
* @param iconImage The icon image id of the venue. requesting images via \"Common Media\" endpoints
* @param website The website url of the venue
*/
@Serializable

data class Venue (


      /* The venue id */
    @SerialName(value = "id") @Required val id: kotlin.Int,


      /* The venue name */
    @SerialName(value = "name") @Required val name: kotlin.String,


      @SerialName(value = "address") val address: Address? = null,


      /* The header image id of the venue. requesting images via \"Common Media\" endpoints */
    @SerialName(value = "headerImage") val headerImage: kotlin.uuid.Uuid? = null,


      /* The icon image id of the venue. requesting images via \"Common Media\" endpoints */
    @SerialName(value = "iconImage") val iconImage: kotlin.uuid.Uuid? = null,


      /* The website url of the venue */
    @SerialName(value = "website") val website: kotlin.String? = null


) {




  }

